import React from 'react'
import Router from './pages/Router'

export const App = () => {
  return <Router />
}
